module.exports = __webpack_public_path__ + "static/media/kitchen-min.6a10f086.jpg";